<section class="profile-content">

    <ng-container [ngSwitch]="active">

        <!-- Mi perfil -->
        <div *ngSwitchCase="'profile'" class="pc-block">
            <app-profile-contact 
                [profileData]="profileData"
                (profileAction)="onProfileAction($event)">
            </app-profile-contact>
        </div>

        <div *ngSwitchCase="'profile-modification'" class="pc-block">
            <app-profile-contact-edition
                (profileAction)="onProfileAction($event)">
            </app-profile-contact-edition>
        </div>

        <div *ngSwitchCase="'bank'" class="pc-block">
            <app-profile-bank
                [paymentData]="paymentData"
                (profileAction)="onProfileAction($event)">
            </app-profile-bank>
        </div>

        <div *ngSwitchCase="'bank-modification'" class="pc-block">
            <app-profile-bank-edition
                (profileAction)="onProfileAction($event)">
            </app-profile-bank-edition>
        </div>

        <!-- Placeholders -->
        <div *ngSwitchCase="'change-password'" class="pc-block">
            <app-profile-password></app-profile-password>
        </div>
        <div *ngSwitchCase="'receipts'" class="pc-block">
            <app-profile-receipts></app-profile-receipts>
        </div>
        <div *ngSwitchCase="'insured'" class="pc-block">
            <app-profile-insured></app-profile-insured>
        </div>
        <div *ngSwitchCase="'notifications'" class="pc-block">
            <app-profile-notifications></app-profile-notifications>
        </div>
        <div *ngSwitchCase="'consent'" class="pc-block">
            <app-profile-consent></app-profile-consent>
        </div>
        <div *ngSwitchCase="'help'" class="pc-block">
            <app-profile-support></app-profile-support>
        </div>

    </ng-container>
</section>
